import React from "react";
import { useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import { getStorage } from "../services/localStorageService";

const TwoFactorApproval = () => {
    const { status } = useParams();
    const isSuccess = status === "success";

    const background = getStorage("background") || "url(/static/media/1.cfde328c.png)"

    return (
        <div
            className="d-flex align-items-center justify-content-center"
            style={{ minHeight: "100vh", background: background }}
        >
            <Container className="text-center">
                <div
                    className="p-4 d-flex flex-column align-items-center shadow rounded bg-white"
                    style={{ maxWidth: "480px", margin: "auto" }}
                >
                    <img
                        src={require("../assets/images/login-logo.png").default}
                        className="logo mb-5"
                    />

                    {isSuccess ? (
                        <>
                            <i
                                className="fa fa-check-circle text-success mb-3"
                                style={{ fontSize: "64px" }}
                            />

                            <h4 className="mb-2">Email Change Approved</h4>
                            <p className="text-muted">
                                Your email change request has been successfully verified.
                                You may now continue with OTP verification.
                            </p>
                        </>
                    ) : (
                        <>
                            <i
                                className="fa fa-times-circle text-danger mb-3"
                                style={{ fontSize: "64px" }}
                            />
                            <h4 className="mb-2">Approval Failed</h4>
                            <p className="text-muted">
                                The email approval link is invalid or has expired.
                                Please request a new verification email.
                            </p>
                        </>
                    )}
                </div>
            </Container>
        </div>
    );
};

export default TwoFactorApproval;
